import { useState } from 'react';
import { TinyERPPage } from './TinyERPPage';
import { CutAppIntegrationPage } from './CutAppIntegrationPage';

type ErpPlatform = 'tiny' | 'bling' | 'cutapp';

interface Erp {
  id: ErpPlatform;
  name: string;
  status: 'beta' | 'coming_soon';
  icon: JSX.Element;
  description: string;
}

const ERPS: Erp[] = [
  {
    id: 'tiny',
    name: 'Tiny ERP',
    status: 'beta',
    description: 'Integração de pedidos e contatos',
    icon: (
      <div className="w-10 h-10 bg-[#0055FF] rounded-xl flex items-center justify-center text-white font-bold text-sm">
        Tiny
      </div>
    )
  },
  {
    id: 'cutapp',
    name: 'Cut App',
    status: 'beta',
    description: 'Importação de produtos e preços por marketplace',
    icon: (
      // Logo oficial em public/cutapp.svg (mesmo padrao dos icones de marketplace).
      <div className="w-10 h-10 rounded-xl bg-white border border-gray-200 flex items-center justify-center overflow-hidden">
        <img src="/cutapp.svg" alt="Cut App" className="w-8 h-8 object-contain" />
      </div>
    )
  },
  {
    id: 'bling',
    name: 'Bling',
    status: 'coming_soon',
    description: 'Integração de pedidos e contatos',
    icon: (
      <div className="w-10 h-10 bg-[#28b86e] rounded-xl flex items-center justify-center text-white font-bold text-sm">
        Bling
      </div>
    )
  }
];

export function ErpsPage() {
  const [selectedPlatform, setSelectedPlatform] = useState<ErpPlatform | null>(null);

  if (selectedPlatform === 'tiny' || selectedPlatform === 'cutapp') {
    return (
      <div className="space-y-4">
        <button
          onClick={() => setSelectedPlatform(null)}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 px-6 pt-6 font-medium"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Voltar para ERPs
        </button>
        {selectedPlatform === 'tiny' ? <TinyERPPage /> : <CutAppIntegrationPage />}
      </div>
    );
  }

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">📦 ERPs (importação de pedidos)</h1>
        <p className="text-gray-600">
          Conecte sua conta aos principais ERPs do mercado para importar e criar automações de mensagens para seus clientes.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {ERPS.map((platform) => (
          <button
            key={platform.id}
            onClick={() => platform.status === 'beta' ? setSelectedPlatform(platform.id) : null}
            className={`flex flex-col items-center p-6 bg-white rounded-xl border transition-all text-center relative ${
              platform.status === 'beta' 
                ? 'border-gray-200 hover:border-blue-300 hover:shadow-md cursor-pointer' 
                : 'border-gray-100 opacity-70 cursor-not-allowed'
            }`}
          >
            {platform.status === 'beta' ? (
              <span className="absolute top-3 right-3 px-2.5 py-0.5 bg-blue-100 text-blue-700 text-[10px] font-bold rounded-full uppercase tracking-wider">
                BETA
              </span>
            ) : (
              <span className="absolute top-3 right-3 px-2.5 py-0.5 bg-gray-100 text-gray-600 text-[10px] font-bold rounded-full uppercase tracking-wider">
                EM BREVE
              </span>
            )}
            
            <div className="mb-4">
              {platform.icon}
            </div>
            
            <h3 className="font-semibold text-gray-900 mb-1">{platform.name}</h3>
            <p className="text-xs text-gray-500">{platform.description}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
